<template>
  <div class="text-center">
    <h3 class="text-h2 mb-8">Need Help?</h3>
    <p class="text-body text-grey-body">
      Questions? Visit our
      <a
        class="underline text-grey-clickable"
        href="https://support.sittercity.com/hc/en-us/articles/115012438408-Run-a-background-check-on-a-caregiver"
        target="_blank"
        >Help Center</a
      >
      or
      <a
        class="underline text-grey-clickable"
        href="https://support.sittercity.com/hc/en-us/requests/new?ticket_form_id=744207"
        target="_blank"
      >
        contact support</a
      >.
    </p>
    <p class="text-grey-body text-small mt-16 md-1:mt-32">
      Background checks are processed by Checkr. Badge results expire after 90 days.
    </p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BGCFooter',
};
</script>
